var render = function render(){var _vm=this,_c=_vm._self._c;return _c('css-sign',{attrs:{"src":_vm.src,"size":_vm.size,"show":_vm.show},on:{"imgclick":_vm.imgClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }